export default __webpack_public_path__ + "locales/pl/DeleteDialog.json?hash=9fb1a89697f1ca0a56bb01fcd2566867";